export function XrayPermissionsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.PERMISSIONS + '/:param')
        .setCustomActions({
            'getInstances': {
                method: 'GET',
                path: '/permissions/instances/resources'
            },
            'getOneInstance': {
                method: 'GET',
                path: '/permissions/resources/:name',
                params: {name: '@name'}
            },
            'activate': {
                method: 'POST',
                params: {param: 'activate'}
            },
            'getMigrationStatus': {
                method: 'GET',
                path: '/migration/data/resources'
            },
            'getGroups': {
                method: 'GET',
                path: '/groups',
                notifications: true
            },
            'getUsers': {
                method: 'GET',
                path: '/users?perms=true',
                isArray: true,
                notifications: true
            },
            'deleteRule': {
                method: 'DELETE',
                params: {param: '@permissionName'}
            },
            'getPermission': {
                method: 'GET',
                params: {param: '@permissionName'}
            },
            'create': {
                method: 'POST',
                notifications: true
            },
            'update': {
                method: 'PUT',
                params: {param: '@name'},
                notifications: true
            },
            'getRules': {
                method: 'GET',
                isArray: true
            },
	        'getCurrent': {
		        method: 'POST',
		        params: {param: 'current'}
	        }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/permissions_dao.js